<template>
    <span>
        <span v-if="internalValue" :titlex="formatDate(internalValue)">{{ showDate() }}</span>
        <span v-if="!internalValue">-</span>
    </span>
</template>

<script>
    import moment from "moment";

    export default {
        name: 'Date',
        props: ['value','label','name','placeholder','human','useLocalTz'],
        data: function () {
            return {
                internalValue: '',
                localTz: false
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.localTz = this.useLocalTz ? true : false;
        },
        methods: {
            showDate: function(){
                if( this.human )
                {
                    return this.$helpers.utcToLocal(this.internalValue, this.$store.state.scope.timezone).fromNow()

                }else{
                    return this.formatDate(this.internalValue)
                }
            },
            formatDate: function(value){

              return this.$helpers.utcToLocal(value, this.$store.state.scope.timezone).format('DD.MM.YYYY HH:mm:ss')

            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Datetime.vue